<template>
  <v-container
    v-if="shiftModel"
    class="mt-4">
    <v-row id="wrapper_row">
      <v-col cols="8">
        <v-data-table
          class="border-table"
          density="compact"
          :headers="headers"
          hide-no-data
          item-value="id"
          :items="shiftModelDeductions">
          <template #item="{ item }">
            <tr>
              <td>
                <CalcInputInline
                  field="name"
                  :id="item.id" />
              </td>
              <td>
                <CalcInputInline
                  field="quantity_shiftModelDeduction"
                  :id="item.id"
                  type="number" />
              </td>
              <td>
                <CalcInputCheckbox
                  field="affects_labour_shiftModelDeduction"
                  :id="item.id"
                  class="pl-3" />
              </td>
              <td>
                <CalcInputCheckbox
                  field="affects_machines_shiftModelDeduction"
                  :id="item.id"
                  class="pl-3" />
              </td>
              <td class="text-no-wrap">
                <EmbeddedTableActionButtons
                  data-cy="shiftModelDeduction"
                  :clone-action="() => cloneAction(item.id)"
                  :delete-action="() => deleteAction(item.id)" />
              </td>
            </tr>
          </template>

          <template #[`header.staff_availability`]>
            <div class="pa-4 text-center">
              <v-icon
                color="#0F6DAC"
                v-tooltip="
                  t(
                    'entities.shiftModelDeduction.fields.affects_labour_shiftModelDeduction'
                  )
                "
                size="large">
                mdi-account
              </v-icon>
            </div>
          </template>

          <template #[`header.machine_availability`]>
            <div class="pa-4 text-center">
              <v-icon
                color="#0F6DAC"
                v-tooltip="
                  t(
                    'entities.shiftModelDeduction.fields.affects_machines_shiftModelDeduction'
                  )
                "
                size="large">
                mdi-cog-outline
              </v-icon>
            </div>
          </template>

          <!--  create button and popup -->
          <template #[`header.actions`]>
            <div class="pb-4 text-center">
              <v-btn
                class="mx-1 px-0 mt-4"
                color="#ECE6F0"
                elevated="26"
                max-width="40"
                min-width="40"
                rounded="lg"
                data-cy="add-element-shiftModelDeduction"
                @click="addAction">
                <v-icon
                  color="#0F6DAC"
                  size="x-large">
                  mdi-plus
                </v-icon>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
      <v-col
        id="shift_model_deductions_notes_col"
        cols="4">
        <NotesEditor
          :id="shiftModelId"
          field="shift_model_deductions_notes_shiftModel"
          :placeholder="
            $t(
              'entities.shiftModel.fields.shift_model_deductions_notes_shiftModel'
            )
          " />
      </v-col>
    </v-row>
  </v-container>
</template>

<script setup>
import { computed, onMounted, ref } from "vue";
import { useTranslation } from "i18next-vue";
import EmbeddedTableActionButtons from "@/components/DataTable/EmbeddedTableActionButtons.vue";
import { useSpaceStore } from "@/stores/spaceStore";
import { useRouter } from "vue-router";
import CalcInputInline from "@/components/Elements/CalcInputInline.vue";
import CalcInputCheckbox from "@/components/Elements/CalcInputCheckbox.vue";
import NotesEditor from "@/components/Elements/NotesEditor.vue";

const { t } = useTranslation();
const spaceStore = useSpaceStore();

const shiftModel = ref(null);
const popupForm = ref(false);

const props = defineProps({
  shiftModelId: {
    type: String,
    required: true
  }
});

const shiftModelDeductions = computed(() => {
  return Object.entries(spaceStore.calculationElements).reduce(
    (result, [id, element]) => {
      if (
        id.endsWith("shiftModelDeduction") &&
        spaceStore.calculationElements[props.shiftModelId].children.includes(id)
      ) {
        result.push(Object.assign({}, element, { id }));
      }
      return result;
    },
    []
  );
});

onMounted(() => {
  shiftModel.value = spaceStore.getElement(props.shiftModelId);
});

const headers = computed(() => [
  {
    title: t("entities.shiftModelDeduction.fields.name"),
    align: "start",
    sortable: false,
    key: "name"
  },
  {
    title: t(
      "entities.shiftModelDeduction.fields.quantity_shiftModelDeduction"
    ),
    key: "description",
    sortable: false
  },
  {
    title: t(
      "entities.shiftModelDeduction.fields.affects_labour_shiftModelDeduction"
    ),
    key: "staff_availability",
    sortable: false,
    align: "center"
  },
  {
    // title: t(
    //   "entities.shiftModelDeduction.fields.affects_machines_shiftModelDeduction"
    // ),
    key: "machine_availability",
    sortable: false,
    align: "center",
    width: "20px"
  },

  {
    title: "",
    key: "actions",
    sortable: false
  }
]);

const router = useRouter();

const addAction = () => {
  spaceStore.createElement("shiftModelDeduction", props.shiftModelId);
};

const cloneAction = (id) => {
  spaceStore.prepareClone(id);
  spaceStore.cloneOnServer(props.shiftModelId, false);
};

const deleteAction = (id) => spaceStore.removeElement(id);
</script>

<style scoped>
#shift_model_deductions_notes_col {
  /* min-height: 100px !important; */
  height: calc(100% - 100px) !important;
}

#wrapper_row {
  min-height: 170px;
}
</style>
